import { cn } from '@workspace/lib';
import { CustomPortableText } from '@workspace/ui/PortableText';
import { ProductSummaryCTA } from './ProductSummaryCTA';
import { ProductSummaryHeading } from './ProductSummaryHeading';
import { CTAItem } from '../product-summary.types';

interface ProductSummaryContentProps {
  resolvedHeadingText: string;
  headingFontClass: string;
  description?: any[];
  ctaUnderHeadline: CTAItem[];
  ctaUnderDescription: CTAItem[];
  onAskGregClick: () => void;
  getOpenInNewTab: (item: CTAItem) => boolean;
  contentClassName?: string;
  headingClassName?: string;
  descriptionClassName?: string;
  hyperlinkClassName?: string;
  hyperlinkIconClassName?: string;
}

export function ProductSummaryContent({
  resolvedHeadingText,
  headingFontClass,
  description,
  ctaUnderHeadline,
  ctaUnderDescription,
  onAskGregClick,
  getOpenInNewTab,
  contentClassName,
  headingClassName,
  descriptionClassName,
  hyperlinkClassName,
  hyperlinkIconClassName,
}: ProductSummaryContentProps) {
  return (
    <div className={cn('flex flex-col w-full', contentClassName || 'gap-sm md:gap-lg')}>
      <div className="flex flex-col items-start text-left gap-8">
        {resolvedHeadingText && (
          <ProductSummaryHeading
            text={resolvedHeadingText}
            headingFontClass={headingFontClass}
            className={headingClassName}
          />
        )}
        <ProductSummaryCTA
          ctaItems={ctaUnderHeadline}
          onAskGregClick={onAskGregClick}
          getOpenInNewTab={getOpenInNewTab}
          hyperlinkClassName={hyperlinkClassName}
          hyperlinkIconClassName={hyperlinkIconClassName}
        />
      </div>

      <div className={cn('flex flex-col', descriptionClassName || 'gap-8 md:max-w-175')}>
        {Array.isArray(description) && description.length > 0 && (
          <div className="rich-text-container">
            <CustomPortableText value={description} />
          </div>
        )}

        <ProductSummaryCTA
          ctaItems={ctaUnderDescription}
          onAskGregClick={onAskGregClick}
          getOpenInNewTab={getOpenInNewTab}
          hyperlinkClassName={hyperlinkClassName}
          hyperlinkIconClassName={hyperlinkIconClassName}
        />
      </div>
    </div>
  );
}
